import React from 'react';
import { conf } from '../config/imports';

function Page404() {
  return (
    <div className='App'>
      <header className='wrapper text-center'>
        <a href='/'>
          <img
            src={conf.images.logo_fe_hz_color}
            className='home-logo mb-5'
            alt='logo'
          />
        </a>
        <p>Ooops! Página não encontrada</p>
      </header>
    </div>
  );
}

export default Page404;
